import { render, staticRenderFns } from "./MessageButton.vue?vue&type=template&id=d224a95a&scoped=true&"
import script from "./MessageButton.vue?vue&type=script&lang=ts&"
export * from "./MessageButton.vue?vue&type=script&lang=ts&"
import style0 from "./MessageButton.vue?vue&type=style&index=0&id=d224a95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d224a95a",
  null
  
)

export default component.exports